module.exports = __webpack_public_path__ + "img/icon-eth-white.a1338ac2.svg";